import * as React from 'react';
import classnames from 'classnames';
import { ArticleHeading4 } from '@cian/ui-kit';

import { useDeviceCondition } from '../../../../hooks';

import * as styles from './MoneySourceButtons.css';

import { IMoneySourceProps } from '../../types';
import { EMoneySource } from '../../../../types/reducers/user';
import { MoneySourceButton } from './MoneySourceButton';

interface IProps {
  options: Array<IMoneySourceProps>;
  onChange: (value: EMoneySource) => void;
}

export const MoneySourceButtons = ({ options, onChange }: IProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={styles['wrapper']}>
      <div className={styles['label']}>
        <ArticleHeading4>Счёт размещения</ArticleHeading4>
      </div>

      <div className={classnames(styles['btns'], rootStyle)}>
        {options.map(option => (
          <MoneySourceButton {...option} onChange={onChange} key={option.value} />
        ))}
      </div>
    </div>
  );
};
